import { render, staticRenderFns } from "./avoimet-asiat-card.vue?vue&type=template&id=18e065d0&scoped=true&"
import script from "./avoimet-asiat-card.vue?vue&type=script&lang=ts&"
export * from "./avoimet-asiat-card.vue?vue&type=script&lang=ts&"
import style0 from "./avoimet-asiat-card.vue?vue&type=style&index=0&id=18e065d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e065d0",
  null
  
)

export default component.exports